import { render, staticRenderFns } from "./SubscriptionContainer.vue?vue&type=template&id=54698d40&scoped=true&"
import script from "./SubscriptionContainer.vue?vue&type=script&lang=js&"
export * from "./SubscriptionContainer.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionContainer.vue?vue&type=style&index=0&id=54698d40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54698d40",
  null
  
)

export default component.exports